
import { FAQPage } from './FAQPage';
export default(FAQPage);
